import { html as beautifyHtml } from "js-beautify";

const BEAUTIFY_OPTIONS = {
    indent_size: 2,
    indent_char: " ",
    max_preserve_newlines: 1,
    preserve_newlines: true,
    wrap_line_length: 0,
    end_with_newline: false,
    indent_inner_html: true,
    extra_liners: [],
    content_unformatted: ["pre", "textarea", "script", "style"],
    unformatted: [],
};

/**
 * Pretty-print email HTML for the Raw HTML / VS Code-style source editor.
 * Safe no-op on empty input; never throws on malformed markup.
 * @param {string} html
 * @returns {string}
 */
export const formatEmailHtmlSource = (html) => {
    const source = String(html || "").trim();
    if (!source) return "";

    try {
        return beautifyHtml(source, BEAUTIFY_OPTIONS).trim();
    } catch {
        return source;
    }
};
